import { render, staticRenderFns } from "./SalaryEnergyData.vue?vue&type=template&id=633e5648&scoped=true&"
import script from "./SalaryEnergyData.vue?vue&type=script&lang=js&"
export * from "./SalaryEnergyData.vue?vue&type=script&lang=js&"
import style0 from "./SalaryEnergyData.vue?vue&type=style&index=0&id=633e5648&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "633e5648",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VForm } from 'vuetify/lib/components/VForm';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VCol,VContainer,VForm,VRow})
